import { useParams } from "react-router";

export function useOrganizationListParams() {
  const { customerId } = useParams();

  if (!customerId) {
    throw new Error("Missing required route parameter: customerId");
  }

  return {
    customerId: Number(customerId),
  };
}
